// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LanguageSelectionModal_wrapper__1K4Bd","languageButton":"LanguageSelectionModal_languageButton__1d9DR","icon":"LanguageSelectionModal_icon__l3tdb"};